import 'https://esm.archive.org/@internetarchive/elements@^0.2.6/ia-dropdown-search-bar/ia-dropdown-search-bar';

const advancedSearchCategoryId = '__advancedsearch__';

function trackEvent({ event }) {
  if (!window.archive_analytics) return;
  const [category, action] = event.split('|');
  window.archive_analytics.send_event_no_sampling(
    category,
    action,
    window.location.pathname,
  );
}

function getSearchHost() {
  // If searching in a dev.archive.org review app, keep the search within it.
  // Otherwise, go to the prod archive.org site.
  return window.location.hostname.endsWith('.dev.archive.org')
    ? window.location.host
    : 'archive.org';
}

function handleSearchRequested({ detail }) {
  trackEvent({ event: 'TopNav|NavSearchSubmit' });
  if (detail.category === 'web' && detail.query) {
    window.location.href = `https://web.archive.org/web/*/${detail.query}`;
    return;
  }

  const params = new URLSearchParams();
  if (detail.query) params.set('query', detail.query);
  if (detail.category) params.set('tab', detail.category);
  window.location.href = `https://${getSearchHost()}/search?${params.toString()}`;
}

function setupSearchBarListeners() {
  const searchBar = document.querySelector('ia-topnav ia-dropdown-search-bar');

  searchBar?.addEventListener('searchRequested', handleSearchRequested);
  searchBar?.addEventListener('categoryChanged', (e) => {
    if (e.detail === advancedSearchCategoryId) {
      searchBar.selectedCategory = 'all';
      trackEvent({ event: 'TopNav|AdvancedSearchClicked' });
      window.location.href = `https://${getSearchHost()}/advancedsearch.php`;
      return;
    }

    trackEvent({ event: 'TopNav|SearchCategoryChanged' });
  });
}

function updateSearchCategories() {
  const searchBar = document.querySelector('ia-topnav ia-dropdown-search-bar');

  const advancedSearchLabel = document.createElement('span');
  advancedSearchLabel.textContent = 'Go to Advanced Search...';
  // Add a separator border above the Advanced Search option, and cancel its extra padding
  advancedSearchLabel.style.borderTop = '1px solid #999';
  advancedSearchLabel.style.marginLeft = '-10px';
  advancedSearchLabel.style.marginRight = '-10px';

  const advancedSearchCategory = {
    id: advancedSearchCategoryId,
    label: advancedSearchLabel,
  };

  searchBar.categories = searchBar.categories.concat(advancedSearchCategory);
  searchBar.selectedCategory = 'all';
}

document.addEventListener('DOMContentLoaded', () => {
  setupSearchBarListeners();
  updateSearchCategories();
});
